import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalCheckbox,
  NormalInput,
  NormalModal,
  NormalTable,
} from "component/common";
import { withTranslation } from "react-i18next";
import { ItemUom, NewItemUom, updateCommon } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";
import { BsPencilSquare } from "react-icons/bs";
import closeIcon from "assets/images/close.png";

export class ItemUOMClass extends Component {
  state = {
    headerDetails: [
      { label: "UOM" },
      { label: "Description" },
      { label: "Is active" },
      { label: "Action", divClass: "justify-content-center" },
    ],
    staffList: [],
    is_loading: false,
    isAboutPopModal: false,
    isNewdescPopModal: false,
    newid: "",
    newval: "",
    editid: null,
    editval: null,
    isActive: true,
    checked: true,
  };

  componentDidMount = () => {
    this.Listofuoms({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  handleIsActive = ({ target: { checked } }) => {
    this.setState({ isActive: checked });
  };

  Listofuoms = async () => {
    this.updateState({ is_loading: true });
    await this.props.ItemUom().then((res) => {
      console.log(res);
      let { staffList } = this.state;

      staffList = res;
      console.log(staffList);
      this.setState({
        staffList,
        is_loading: false,
      });
      console.log(staffList.length);
    });
  };

  aboutpopup() {
    this.setState({
      isAboutPopModal: !this.state.isAboutPopModal,
    });
  }

  newdescpopup() {
    this.setState({
      isNewdescPopModal: !this.state.isNewdescPopModal,
    });
  }

  handledesc = ({ target: { value, name } }) => {
    let { editval, newid, checked } = this.state;
    if ((name = "desc")) {
      editval = value;
      this.setState({ editval });
    }
    if ((name = "newid")) {
      newid = value;
      this.setState({ newid });
    }
    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
  };
  temp = ({ target: { value, name } }) => {
    let { checked } = this.state;

    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
  };
  handleeditid = ({ target: { value, name } }) => {
    let { editid } = this.state;
    if ((name = "code")) {
      editid = value;
      this.setState({ editid });
      console.log(editid);
    }
  };

  handledescription = ({ target: { value, name, checked } }) => {
    let { newval, isActive } = this.state;
    if (name === "newdescval") {
      newval = value;
      isActive = checked;
      this.setState({
        newval,
        isActive,
      });
    }
  };

  handleEdit(id, desc, isActive) {
    console.log(isActive, "isActive");
    let { editid, editval, checked } = this.state;
    editid = id;
    editval = desc;
    checked = isActive;
    this.setState({
      editid,
      editval,
      checked,
    });
    this.aboutpopup();
  }

  createdesc = async (id, val) => {
    const { isActive, checked } = this.state;
    let newuoms = {
      uomCode: id,
      uomDesc: val,
      uomIsactive: checked,
    };
    console.log(newuoms, "uom");
    await this.props
      .NewItemUom(newuoms)
      .then((data) => {
        this.Listofuoms({});
        Toast({
          type: "success",
          message: "Successfully Added",
        });
      })
      .catch((e) => console.log(e));
    this.newdescpopup();
  };

  finaldesc = async (id, desc, isActive) => {
    let { editval, newval, newid, checked } = this.state;
    console.log(id, desc);
    let descJson = {
      uomCode: id,
      uomDesc: desc,
      uomIsactive: checked,
      uomUser: null,
      uomDate: null,
      uomTime: null,
    };
    await this.props
      .updateCommon(
        `ItemUoms/update?where=%7B%22uomCode%22%3A%20%22${id}%22%7D
    `,
        descJson
      )
      .then((data) => {
        this.Listofuoms({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      });
    this.aboutpopup();
    editval = "";
    newval = "";
    newid = "";
    this.setState({ editval, newval, newid, isActive });
  };

  // handlecheckbox = async (item) => {
  //   let { staffList } = this.state;
  //   for (let i = 0; i <= staffList.length - 1; i++) {
  //     if (staffList[i].uomCode === item) {
  //       staffList[i].uomIsactive = !staffList[i].uomIsactive;
  //       let descJson = {
  //         uomCode: staffList[i].uomCode,
  //         uomDesc: staffList[i].uomDesc,
  //         uomIsactive: staffList[i].uomIsactive,
  //         uomUser: null,
  //         uomDate: null,
  //         uomTime: null,
  //       };
  //       await this.props
  //         .updateCommon(
  //           `ItemUoms/update?where=%7B%22uomCode%22%3A%20%22${item}%22%7D
  //   `,
  //           descJson
  //         )
  //         .then((data) => {
  //           this.Listofuoms({});
  //         });
  //     }
  //   }
  // };

  render() {
    let {
      headerDetails,
      staffList,
      is_loading,
      isAboutPopModal,
      editid,
      editval,
      newid,
      newval,
      checked,
      isNewdescPopModal,
      isActive,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                    {t("Item Classification")}
                  </h4>
                </div>
                <div className="col-12">
                  <p className="label-title text-center text-md-left text-lg-left mt-2">
                    {t("UOM List")}
                  </p>
                </div>
              </div>
              <div className="tab-table-content">
                <div className="py-4">
                  <div className="table-container">
                    <NormalTable headerDetails={headerDetails}>
                      {is_loading ? (
                        <tr>
                          <td colSpan="7">
                            <div class="d-flex mt-5 align-items-center justify-content-center">
                              <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : staffList.length > 0 ? (
                        staffList.map(
                          ({ uomCode, uomDesc, uomIsactive }, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="text-left">{uomCode}</div>
                                </td>
                                <td>
                                  <div className="text-left">{uomDesc}</div>
                                </td>
                                <td>
                                  <div className="text-left">
                                    <NormalCheckbox
                                      checked={uomIsactive}
                                      name="checked"
                                      onChange={() =>
                                        this.handlecheckbox(uomCode)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="text-left">
                                    <BsPencilSquare
                                      size={20}
                                      onClick={() =>
                                        this.handleEdit(
                                          uomCode,
                                          uomDesc,
                                          uomIsactive
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : null}
                    </NormalTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-3 mb-3 col-12 col-md-3" style={{ width: "100%" }}>
            <NormalButtonBackend
              mainbg={true}
              label={"Add Row"}
              onClick={() => this.newdescpopup()}
            />
          </div>
        </div>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isAboutPopModal}
          handleModal={() => this.aboutpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.aboutpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>

          <div className="col-12">
            <div className="text-center">
              <h5> EDIT DESCRIPTION </h5>
            </div>
            <div className="col-12">
              <div className="">
                <h6>UOM</h6>
                <NormalInput
                  value={editid}
                  name="code"
                  onChange={this.handleeditid}
                  disabled
                />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={editval}
                  name="desc"
                  onChange={this.handledesc}
                />
              </div>
              <div className="col-12">
                <h6>Active</h6>
                <NormalCheckbox
                  checked={checked}
                  name="checked"
                  onChange={this.temp}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.aboutpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.finaldesc(editid, editval, isActive)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>

        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isNewdescPopModal}
          handleModal={() => this.newdescpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.newdescpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
              <h5> ADD DESCRIPTION</h5>
            </div>
            <div className="col-12">
              <div className="">
                <h6>UOM</h6>
                <NormalInput
                  value={newid}
                  name="newid"
                  onChange={this.handledesc}
                />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={newval}
                  name="newdescval"
                  onChange={this.handledescription}
                />
              </div>
              <div className="col-12">
                <NormalCheckbox
                  checked={checked}
                  name="checked"
                  onChange={this.temp}
                />
                <p>{t("Active")}</p>
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.newdescpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.createdesc(newid, newval, isActive)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      NewItemUom,
      ItemUom,
      updateCommon,
    },
    dispatch
  );
};

export const ItemUOM = withTranslation()(
  connect(null, mapDispatchToProps)(ItemUOMClass)
);
